module.exports = __webpack_public_path__ + "static/adv4-40a6cda7624a362636d7ae2472e63e9b.png";